// Full searchable radio details from the supplied 2023 statewide channel plan.
export default String.raw`23.1|151.32500|131.8|159.36000|000.0|H|N|NEU LOCAL WEST
23.2|154.13000|131.8|159.49500|000.0|H|N|NEU LOCAL EAST
23.3|153.96500|100.0|156.33000|000.0|H|N|NEVADA CO FIRE
23.4|155.98500|186.2|154.01000|000.0|H|N|FOOTHILL FIRE
23.5|154.35500|107.2|158.89500|000.0|H|N|PLACER FIRE DISPATCH WEST
23.6|169.90000|000.0|168.77500|000.0|H|N|USFS TAHOE NF FOREST NET
23.7|170.60000|000.0|164.93750|000.0|H|N|TAHOE NF FIRE NET Fall 2018
23.8|172.37500|156.7|164.96250|000.0|H|N|USFS Lake Tahoe MU Basin 1 Net
23.9|151.35500|103.5|159.30000|000.0|H|N|CDF COMMAND 1
23.10|151.26500|103.5|159.33000|000.0|H|N|CDF COMMAND 2
23.11|151.46000|103.5|159.39000|000.0|H|N|CDF COMMAND 7
23.12|151.16000|192.8|151.16000|192.8|L|N|CDF TAC 2
23.13|151.25000|192.8|151.25000|192.8|L|N|CDF TAC 5
23.14|151.38500|192.8|151.38500|192.8|L|N|CDF TAC 9
23.15|154.28000|156.7|154.28000|156.7|H|N|VFIRE 21
23.16|154.26500|156.7|154.26500|156.7|L|N|VFIRE 22
23.17|154.29500|156.7|154.29500|156.7|L|N|VFIRE 23
23.18|154.27250|156.7|154.27250|156.7|H|N|VFIRE 24
23.19|154.28750|156.7|154.28750|156.7|H|N|VFIRE 25
23.20|154.30250|156.7|154.30250|156.7|H|N|VFIRE 26
23.21|168.20000|000.0|168.20000|000.0|L|N|NIFC TAC 2 (TNF Primary)
23.22|166.55000|000.0|166.55000|000.0|L|N|USFS RGN 5 TAC 4 (TNF Sec)
23.23|167.11250|000.0|167.11250|000.0|L|N|USFS RGN 5 TAC 5 (TNF Sec)
23.24|168.23750|000.0|168.23750|000.0|L|N|USFS RGN 5 TAC 6 (TNF Sec)
23.25|156.07500|156.7|156.07500|156.7|H|N|California On-Scene Coordination
23.26|151.22000|192.8|151.22000|192.8|L|N|CDF AIR TO GND NET 1
23.27|159.36750|192.8|159.36750|192.8|L|N|CDF AIR TO GND NET 3
23.28|167.50000|000.0|167.50000|000.0|L|N|IA Air/Ground Primary CAO2
23.29|169.11250|000.0|169.11250|000.0|L|N|IA Air/Ground Secondary CAO2
23.30|166.87500|000.0|166.87500|000.0|L|N|FED A/G MINDEN
23.31|168.31250|000.0|168.31250|000.0|L|N|FED A/G MINDEN
23.32|168.48750|000.0|168.48750|000.0|L|N|FED A/G MINDEN
23.33|158.89500|000.0|156.07500|000.0|H|N|NEVADA DIV. FORESTRY
23.34|168.66250|000.0|168.66250|000.0|L|N|R5 PROJECT NET
23.35|171.57500|156.7|165.41250|000.0|H|N|TMU ADMIN NET
23.36|172.32500|156.7|165.22500|000.0|H|N|ENF ADMIN NET
23.37|171.52500|156.7|162.75000|000.0|H|N|ENF FOREST NET
23.38|173.76250|156.7|164.82500|000.0|H|N|ENF SERVICE NET
23.39|173.77500|000.0|165.75000|000.0|H|N|USFS TOIYABE NF
23.40|171.42500|000.0|163.16250|000.0|H|N|PLUMAS ADMIN NET
23.41|170.55000|000.0|164.87500|000.0|H|N|USFS PLUMAS FOREST NET
23.42|153.95000|100.0|154.44500|000.0|H|N|SLT DISP. Use tone 9
23.43|153.99500|162.2|155.94000|000.0|H|N|SOUTH LAKE OPERATIONS T12
23.44|155.36250|100.0|159.08250|100.0|H|N|SLT LV NET tone 9
23.45|154.34000|100.0|153.89000|100.0|H|N|SLT LV NET tone 9
23.46|154.23500|100.0|154.23500|100.0|H|N|NORTH LAKE TAHOE DISPATCH
23.47|155.02500|151.4|158.77500|167.9|H|N|TAHOE DOUGLAS DISPATCH
23.48|158.74500|000.0|159.39000|000.0|H|N|TRUCKEE MEADOWS DISPATCH
23.49|158.88000|000.0|158.88000|118.8|L|N|TRUCKEE MEADOWS TAC 1
23.50|158.94000|000.0|158.94000|107.2|L|N|TRUCKEE MEADOWS TAC 2
23.51|168.31250|000.0|168.31250|000.0|L|N|Sierra Front Air 1 NVO3 Pri AG-51
23.52|166.87500|000.0|166.87500|000.0|L|N|Sierra Front Air 2 NVO3 Sec AG-8
23.53|151.97000|000.0|159.76500|D047|H|N|TRUCKEE AIRPORT REPEATER
23.54|154.32500|000.0|153.54500|167.9|H|N|TRUCKEE FIRE REPEATED TAC
23.55|154.20500|000.0|154.20500|000.0|L|N|TRUCKEE TAC 1
23.56|159.04500|000.0|159.04500|000.0|L|N|TRUCKEE TAC 2
23.57|154.40000|94.8|153.77000|000.0|H|N|J-TAC (OLD PLCR E.) Tone 6
23.58|168.30000|000.0|168.30000|000.0|H|N|BLM SCENE OF ACTION CALIF NOD
23.59|169.40000|000.0|169.40000|000.0|H|N|BLM SOA 2 - CALIF NOD
23.60|171.67500|000.0|171.67500|114.8|H|N|BLM SOA - NV CARSON DISTRICT
23.61|169.98750|146.2|162.23750|000.0|H|N|BLM CARSON DISTRICT OPERATIONS - MULTI TONES
23.62|153.25250|131.8|160.11000|131.8|L|N|THUNDER VALLEY CASINO TAC 1
23.63|153.00500|131.8|160.02750|131.8|L|N|THUNDER VALLEY CASINO TAC 2
23.64|154.04000|107.2|158.83500|162.2|H|N|ROSEVILLE FIRE DISPATCH
23.65|154.14500|162.2|158.77500|162.2|H|N|ROCKLIN FIRE DISPATCH
23.66|151.01000|151.4|155.83500|151.4|H|N|LINCOLN CITY DISPATCH
23.67|152.81000|131.8|158.07000|000.0|H|N|Placer Co Fire South CMD (New XPL CMD)
23.68|156.24000|110.9|159.12000|000.0|H|N|PLACER COMMAND OLD
23.69|154.17500|118.8|156.39000|000.0|H|N|PLACER TAC 1
23.70|155.02500|107.2|155.62500|107.2|H|N|PLACER TAC 2
23.71|154.01000|107.2|154.01000|107.2|L|N|PLACER TAC 3
23.72|158.80500|127.3|158.80500|127.3|L|N|PLACER TAC 4
23.73|154.23500|107.2|154.23500|107.2|L|N|PLACER TAC 5
23.74|154.40000|107.2|154.40000|107.2|L|N|PLACER TAC 6
23.75|154.13000|107.2|154.13000|107.2|L|N|PLACER TAC 7
23.76|154.07000|103.5|154.07000|103.5|L|N|PLACER TAC 8
23.77|153.89000|107.2|153.89000|107.2|L|N|PLACER TAC 9
23.78|154.20500|103.5|154.20500|103.5|L|N|PLACER TAC 10
23.79|155.35500|000.0|150.77500|000.0|H|N|FOOTHILL MED NET
23.80|153.83000|000.0|153.83000|000.0|L|N|FOOTHILL FIRE TAC 1
23.81|154.14500|000.0|154.14500|000.0|L|N|FOOTHILL FIRE TAC 2
23.82|155.38500|000.0|155.38500|000.0|L|N|FOOTHILL FIRE TAC 3
23.83|155.40000|000.0|155.40000|000.0|L|N|FOOTHILL FIRE TAC 4
23.84|150.79000|192.8|150.79000|192.8|L|N|NEVADA CO. FIRE TAC 1
23.85|155.40000|192.8|155.40000|192.8|L|N|NEVADA CO. FIRE TAC 2
23.86|155.34000|000.0|155.34000|156.7|L|N|NEVADA ON-SCENE COORDINATION
23.87|155.34750|000.0|155.34750|156.7|L|N|NEVADA ON-SCENE COORDINATION
23.88|153.93500|100.0|158.88000|100.0|H|N|SUTTER COUNTY FIRE NORTH
23.89|153.93500|100.0|158.88000|167.9|H|N|SUTTER COUNTY FIRE SOUTH
23.90|153.77000|100.0|153.77000|100.0|L|N|SUTTER COUNTY TAC 1
23.91|154.08500|131.8|154.08500|131.8|L|N|SUTTER COUNTY TAC 2
23.92|158.89500|100.0|158.89500|100.0|L|N|SUTTER COUNTY TAC 3
23.93|155.29500|100.0|154.13000|123.0|H|N|MARYSVILLE COMMAND NET
23.94|154.34000|103.5|156.01500|103.5|H|N|YUBA CITY FD TAC 1
23.95|154.17500|100.0|158.98500|100.0|H|N|YUBA CITY FIRE DISPATCH
23.96|154.25000|100.0|155.86500|000.0|H|N|YUBA COUNTY COMMAND
23.97|154.20500|100.0|154.20500|100.0|L|N|YUBA COUNTY TAC 1
23.98|154.31000|000.0|154.31000|100.0|L|N|YUBA COUNTY TAC 2
23.99|154.07000|000.0|154.07000|110.9|L|N|YUBA COUNTY TAC 3
23.100|155.26500|100.0|159.04500|100.0|H|N|YUBA COUNTY TAC 4
23.101|153.47000|100.0|159.75000|100.0|H|N|YUBA COUNTY TAC 5
23.102|154.96500|131.8|158.97750|100.0|H|N|DOWNIEVILLE FIRE - RUBY PEAK
23.103|154.10750|000.0|159.17250|131.8|H|N|SIERRA CITY FIRE - HILDA REPEATER
23.104|158.94000|000.0|158.94000|156.7|H|N|PIKE CITY DISPATCH RPTR (SIMPLEX REPEATER)
23.105|158.94000|167.9|153.87500|131.8|H|N|PIKE CITY LOCAL USE REPEATER
23.106|154.38500|000.0|154.38500|94.8|H|N|ALLEGHANY FIRE REPEATER (SIMPLEX RPTR)
23.107|154.38500|000.0|153.89000|167.9|H|N|EAST SIERRA COUNTY FIRE - BABBITT LO
23.108|154.38500|000.0|153.89000|156.7|H|N|EAST SIERRA COUNTY FIRE - BECKWOURTH
23.109|154.38500|000.0|153.89000|123.0|H|N|EAST SIERRA COUNTY FIRE - HARDING POINT
23.110|154.17500|000.0|154.17500|000.0|H|N|EAST SIERRA COUNTY FIRE - TACTICAL
23.111|154.38500|000.0|153.89000|103.5|H|N|EAST SIERRA COUNTY FIRE - YUBA PASS
23.112|154.23500|000.0|158.93250|156.7|H|N|LOYALTON FIRE REPEATER
23.113|155.08500|103.5|158.95500|000.0|H|N|PLUMAS CO FIRE REPEATER OST
23.114|154.92000|156.7|154.92000|156.7|H|N|LE TACTICAL - OLD CLEMARS 1
23.115|154.93500|156.7|154.93500|156.7|L|N|LE TACTICAL - OLD CLEMARS 2
23.116|155.47500|000.0|155.47500|156.7|H|N|LE TACTICAL - OLD NALMARS
23.117|155.48250|156.7|155.48250|156.7|H|N|LE TACTICAL
23.118|160.54500|131.8|000.00000|000.0||N|PCSO LAW NET WEST
23.119|161.50500|136.5|000.00000|000.0||N|PCSO LAW NET TAHOE
23.120|160.66500|136.5|000.00000|000.0||N|PCSO LAW ADMIN EAST
23.121|155.56500|141.3|000.00000|000.0||N|NCSO LAW NET West Banner
23.122|155.76000|156.7|000.00000|000.0||N|NCSO LAW NET TRUCKEE
23.123|155.10000|229.1|000.00000|000.0||N|NCSO TAC NET
23.124|153.90500|97.4|000.00000|000.0||N|TRUCKEE PD (SIMULCAST NCSO)
23.125|154.04000|000.0|000.00000|000.0||N|TRUCKEE PD SECONDARY
23.126|154.65000|000.0|000.00000|000.0||N|AUBURN PD
23.127|159.55500|136.5|000.00000|000.0||N|EL DORADO SO WEST SLOPE
23.128|159.60000|136.5|000.00000|000.0||N|EL DORADO SO EAST SLOPE
23.129|153.78500|173.8|000.00000|000.0||N|SIERRA CO SO
23.130|168.62500|000.0|168.62500|110.9|L|N|Emergency`;
